import { render } from "./sku-item.vue?vue&type=template&id=b854c34e&scoped=true&ts=true"
import script from "./sku-item.vue?vue&type=script&lang=ts"
export * from "./sku-item.vue?vue&type=script&lang=ts"

import "./sku-item.vue?vue&type=style&index=0&id=b854c34e&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b854c34e"]])

export default __exports__